import { authApi } from "@/api/admin/auth/authApi";
import { authRestaurantApi } from "@/api/restaurant/auth/authRestaurantApi";
import { restaurantApi } from "@/api/restaurant/restaurantApi";
import { deriveRestaurantRole } from "@/services/auth/deriveRestaurantRole";
import { resolvePortalType } from "@/services/auth/resolvePortalType";
import { getStoredTokens } from "@/services/auth/tokenStorage";
import { AuthRole } from "@/store/AuthStore";
import { rootStore } from "@/store/RootStore";

export async function initializeAuth(): Promise<void> {
  const { authStore, adminAccessStore } = rootStore;

  if (authStore.isLegacySession && authStore.token) {
    authStore.setInitialized();
    return;
  }

  const tokens = getStoredTokens();

  if (!tokens) {
    authStore.setInitialized();
    return;
  }

  authStore.setTokens(tokens.token, tokens.refreshToken);

  const portalType = resolvePortalType();

  try {
    if (portalType === AuthRole.ADMIN) {
      const me = await authApi.getMe();
      authStore.loginAsSuperAdmin(me.admin);
      adminAccessStore.setPermissions(me.permissions);
    } else {
      const me = await authRestaurantApi.getMe();
      const assignment = await restaurantApi.getOptionsAssignments();
      const role = deriveRestaurantRole(assignment);

      authStore.loginAsRestaurant({ ...me.restaurantUser, role });
    }
  } catch {
    authStore.clearSession();
  } finally {
    authStore.setInitialized();
  }
}
